import React, { useEffect, useState } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { useNavigate } from 'react-router-dom';
import { useSentimentAnalysisApi } from '../../store/api/hooks/sentimentAnalysisApiHook';
import { useAuthStatus, useStoreSelector, useStoreBrnDSSelector } from '../../store/selectors/userSelector';
import { toast } from 'react-hot-toast';
// import { format } from 'date-fns';
import moment from 'moment';
import Spinner from '../../components/iconSvgs/spinner';
import { SentimentTimelineProps } from '../../_config/interfaces/interfaces';
import { formatDate } from '../../_common/functions';

const SentimentTimeline: React.FC<SentimentTimelineProps> = ({ filterValue }) => {
    const [sentimentTimeline, setSentimentTimeline] = useState<any[]>([]);
    const [isOnSubmitLoading, setOnSubmitLoading] = useState<boolean>(false);


    const sentimentAPI: any = useSentimentAnalysisApi();
    const navigate = useNavigate();
    const isAuth = useAuthStatus();
    const branchDS = useStoreBrnDSSelector();
    // console.log('useEffect =>', branchDS);

    useEffect(() => {
        if (filterValue !== null) {
            applyFilter(filterValue); // This is called automatically when filterValue changes
        } else {
            getSentimentTimeline({});
        }
    }, [filterValue]);

    const applyFilter = (filterValue: any) => {
        // console.log('filterValue =>', filterValue); 
        getSentimentTimeline(filterValue);
    }

    const getSentimentTimeline = (param: any) => {
        setOnSubmitLoading(true);
        let params: any;
        if (param) {
            params = { branch_id: branchDS?.branch_id, ...param };
        } else {
            params = { branch_id: branchDS?.branch_id };
        }
        try {
            setTimeout(() => {
                sentimentAPI.getSentimentTimeline(params, (msg: any, resp: any) => {
                    setSentimentTimeline(resp.data);
                }, (err: any, resp: any) => {
                    toast.error(resp?.detail?.message);
                })
                setOnSubmitLoading(false);
            }, 3000);

        } catch (err: any) {
            toast.error(err);
            setOnSubmitLoading(false);
        }
    }

    return (
        <>
            {isOnSubmitLoading && (
                <div className="absolute inset-0 bg-gray-700 bg-opacity-50 flex justify-center items-center z-50">
                    <Spinner className="self-center z-50" />
                </div>
            )}
            <ResponsiveContainer width={"100%"} height={300}>
                <BarChart
                    data={sentimentTimeline}
                    margin={{
                        top: 20,
                        right: 30,
                        left: 20,
                        bottom: 5,
                    }}
                    barGap={0}
                    barCategoryGap="5%"
                >
                    <CartesianGrid vertical={false} strokeDasharray="3 3" />
                    <XAxis
                        dataKey="date"
                        tickFormatter={formatDate}
                    />
                    <YAxis
                        tickFormatter={(value) => value % 1 === 0 ? value : ''}
                        domain={[0, Math.max(...sentimentTimeline.map((item) => item?.positive + item?.negative + item?.mixed + item?.neutral))]}  // Manually setting the max value for scaling
                        tickCount={5}
                    />

                    <Tooltip cursor={{ fill: 'rgba(148, 163, 184, 0.14)' }} />
                    <Legend />
                    <Bar dataKey="negative" stackId="a" fill="#f87171" barSize={10} />
                    <Bar dataKey="positive" stackId="a" fill="#82ca9d" />
                    <Bar dataKey="mixed" stackId="a" fill="#9ca3af" barSize={10} />
                    <Bar dataKey="neutral" stackId="a" fill="#EED202" />
                    {/* <Bar dataKey="negative" stackId="a" fill="#EF5350" barSize={10} /> 
                <Bar dataKey="positive" stackId="a" fill="#66BB6A" />
                <Bar dataKey="mixed" stackId="a" fill="#ced4da" barSize={10} />
                <Bar dataKey="neutral" stackId="a" fill="#ffe400" /> */}
                </BarChart>
            </ResponsiveContainer>
        </>
    );
};

export default SentimentTimeline;
